export default function checkForSession(props) {

    props.history.push({
        pathname: '/',
        state: {
            token: props.token,
            title: props.title,
            createdBy: props.createdBy,
        }
    })
}